import React from 'react';
import { Link } from 'react-router-dom';
import { NewsPost, formatNewsDate, summarise } from '../utils/newsApi';

const NewsList: React.FC<{ items: NewsPost[] }> = ({ items }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
    {items.map((post) => (
      <article
        key={post.id}
        className="bg-primary-black border border-primary-gold rounded-lg p-6 flex flex-col"
      >
        <p className="text-sm text-primary-gold mb-2">{formatNewsDate(post.created_at)}</p>
        <h3 className="text-xl font-bold text-white mb-3 font-display">
          <Link to={`/news/${post.url}`} className="hover:text-primary-gold transition-colors">
            {post.title}
          </Link>
        </h3>
        <p className="text-gray-300 text-sm flex-1">{summarise(post)}</p>
        <Link
          to={`/news/${post.url}`}
          className="text-primary-gold text-sm mt-6 underline hover:text-white transition-colors"
          aria-label={`Read more: ${post.title}`}
        >
          Read More
        </Link>
      </article>
    ))}
  </div>
);

export default NewsList;
